import { NavLink, useLocation } from "react-router-dom";
import { LogoButton } from "../Buttons/LogoButton";
import {
  HiOutlineHome,
  HiOutlineCalculator,
  HiOutlineTruck,
  HiOutlineClipboardDocumentList,
  HiOutlineCog,
} from "react-icons/hi2";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const navigation = [
  { name: "Dashboard", to: "/dashboard", icon: HiOutlineHome },
  { name: "Quote", to: "/dashboard/quote", icon: HiOutlineCalculator },
  { name: "Ship", to: "/dashboard/ship", icon: HiOutlineTruck },
  { name: "Orders", to: "/dashboard/orders", icon: HiOutlineClipboardDocumentList },
];

const activeItem = `
  bg-gradient-to-r from-[#0052FF]/20 to-[#0099FF]/20
  text-white font-semibold
  shadow-[0_0_0_1px_rgba(0,153,255,0.25)]
  backdrop-blur-sm
`;

const inactiveItem = `
  text-gray-300 hover:bg-white/10 hover:text-white
`;

const baseItemClasses = `
  group flex items-center gap-x-3 rounded-xl px-3 py-2
  transition-all duration-200 hover:scale-[1.01]
  focus-visible:outline-none focus-visible:ring-2
  focus-visible:ring-[#0099FF]/60
`;

const activeIconClasses = `
  bg-gradient-to-br from-[#0052FF] to-[#0099FF]
  text-white shadow-md
`;

const inactiveIconClasses = `
  bg-white/10 text-gray-300
  group-hover:bg-white/20 group-hover:text-white
`;

export function Sidenav({ navigation: navItems, setSidebarOpen }) {
  const location = useLocation();
  const navList = navItems || navigation;

  return (
    <div className="flex flex-col h-screen z-10 bg-[#0A1A2F] text-white shadow-xl border-r border-gray-200">
      {/* Logo */}
      <div className="flex h-20 items-center px-4 border-b border-white/10">
        <LogoButton />
      </div>

      {/* Navigation */}
      <nav className="flex-1 px-4 mt-6">
        <ul className="space-y-1.5">
          {navList.map((item) => {
            const isActive =
              item.to === "/dashboard"
                ? location.pathname === "/dashboard"
                : location.pathname.startsWith(item.to);

            return (
              <li key={item.name}>
                <NavLink
                  to={item.to}
                  end
                  onClick={() => setSidebarOpen?.(false)}
                  className={classNames(
                    isActive ? activeItem : inactiveItem,
                    baseItemClasses
                  )}
                >
                  {/* Icon */}
                  <div
                    className={classNames(
                      "h-9 w-9 rounded-lg flex items-center justify-center transition-all duration-200",
                      isActive ? activeIconClasses : inactiveIconClasses
                    )}
                  >
                    <item.icon className="h-5 w-5" />
                  </div>

                  <span className="text-sm">{item.name}</span>
                </NavLink>
              </li>
            );
          })}
        </ul>
      </nav>

      {/* Settings */}
      <div className="mt-auto border-t border-white/10 pt-4 px-4 mb-6">
        <NavLink
          to="/dashboard/settings"
          onClick={() => setSidebarOpen?.(false)}
          className={({ isActive }) =>
            classNames(
              isActive ? activeItem : inactiveItem,
              baseItemClasses
            )
          }
        >
          {({ isActive }) => (
            <>
              <div
                className={classNames(
                  "h-9 w-9 rounded-lg flex items-center justify-center transition-all duration-200",
                  isActive ? activeIconClasses : inactiveIconClasses
                )}
              >
                <HiOutlineCog className="h-5 w-5" />
              </div>

              <span className="text-sm">Settings</span>
            </>
          )}
        </NavLink>
      </div>
    </div>
  );
}